<template>
  <div class="step-four-content">
    <div class="white-box">
      <table class="main-table">
        <thead>
          <tr>
            <th class="description">Twoje zamówienie</th>
            <th class="net">netto</th>
            <th class="vat_rate">vat (%)</th>
            <th class="vat">kwota vat</th>
            <th class="gross">brutto</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="getSummary.plan !== null">
            <tr>
              <td class="summary-section" colspan="5">Pakiet podstawowy</td>
            </tr>
            <tr class="plan">
              <td class="description">{{ getSummary.plan.name }} <span class="gray">({{ getSummary.plan.periodName }})</span></td>
              <td class="net gray">{{ toFixedTwo(getSummary.plan.net) }} zł</td>
              <td class="vat_rate gray">{{ getSummary.plan.taxRate }}%</td>
              <td class="vat gray">{{ toFixedTwo(getSummary.plan.tax) }} zł</td>
              <td class="gross">{{ toFixedTwo(getSummary.plan.gross) }} zł</td>
            </tr>
          </template>
          <template v-if="getSummary.extras.length > 0">
            <tr>
              <td class="summary-section" colspan="5">Dodatki</td>
            </tr>
            <tr v-for="(extra, index) in getSummary.extras"
              :key="`extra-${index}`"
              class="extras">
              <td class="description">{{ extra.name }} </td>
              <td class="net gray">{{ toFixedTwo(extra.net) }} zł</td>
              <td class="vat_rate gray">{{ extra.taxRate }}%</td>
              <td class="vat gray">{{ toFixedTwo(extra.tax) }} zł</td>
              <td class="gross">{{ toFixedTwo(extra.gross) }} zł</td>
            </tr>
          </template>
          <template v-if="getSummary.discounts.length">
            <tr>
              <td class="summary-section" colspan="5">Zniżki</td>
            </tr>
            <tr v-for="(discount, index) in getSummary.discounts"
              :key="`discount-${index}`"
              class="discounts">
              <template v-if="discount.gross">
                <td class="description">
                  {{ discount.name }}
                </td>
              </template>
              <template v-else>
                <td class="description has-tooltip package-extend-info" colspan="4">
                  <span class="discount-name">{{ discount.name }}</span>
                  <span class="discounts-extra has-tooltip" v-if="discount.tooltip">
                    <span class="extra">{{ discount.extra }}</span>
                    <span class="tooltip" v-if="discount.tooltip">{{ discount.tooltip }}</span>
                    <img class="special-discount-img" src="../../assets/img/common/icon_question_mark_active.svg" width="16" height="16">
                  </span>
                </td>
                <td class="duration-change-important"><img src="../../assets/img/common/exclamation.svg" width="20" height="20"></td>
              </template>
              <td class="net" v-if="discount.net">{{ toFixedTwo(discount.net) }} zł</td>
              <td class="vat_rate" v-if="discount.taxRate">{{ discount.taxRate }}%</td>
              <td class="vat" v-if="discount.tax">{{ toFixedTwo(discount.tax) }} zł</td>
              <td class="gross" v-if="discount.gross">{{ toFixedTwo(discount.gross) }} zł</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <template v-if="getSummary.packageDurationChange">
      <div class="kcalmar-checkbox">
        <input type="checkbox" id="package-duration-change" v-model="packageExtendCheckbox" checked>
        <label for="package-duration-change" class="package-extend-checkbox-label">Akceptuję zmianę okresu trwania mojego planu
        </label>
      </div>
      <div class="package-extend-error" v-for="error in packageExtendError" :key="`error-${error}`">{{ error }} </div>
    </template>
    <div class="row summary">
      <div class="summary-discount" v-if="codeVisible">
        <input type="text" v-model="code">
        <div class="summary-calculate" v-on:click="checkCode">Przelicz</div>
        <div class="summary-discount-error" v-if="codeError">{{ codeError }}</div>
      </div>
      <div class="summary-discount-link" v-else>
        <div v-on:click="showCode" >Wpisz kod rabatowy &gt;</div>
      </div>
      <div class="summary-total">
        <table>
          <tr class="price">
            <td>koszt</td>
            <td>{{ toFixedTwo(getSummary.totalPriceBeforeDiscountNet) }} zł</td>
          </tr>
          <tr class="vat">
            <td>kwota vat</td>
            <td>{{ toFixedTwo(getSummary.totalTaxBeforeDiscount) }} zł</td>
          </tr>
          <tr class="discount" v-if="getSummary.totalDiscount > 0">
            <td>rabat</td>
            <td>-{{ toFixedTwo(getSummary.totalDiscount) }} zł</td>
          </tr>
          <tr class="savings" v-if="getSummary.totalSavings > 0">
            <td>oszczędzasz</td>
            <td>{{ toFixedTwo(getSummary.totalSavings) }} zł</td>
          </tr>
          <tr class="summary">
            <td>do zapłaty</td>
            <td>{{ toFixedTwo(getSummary.totalPriceGross) }} zł brutto</td>
          </tr>
        </table>
      </div>
    </div>
      <div class="row white-box">
        <div class="header">Dane klienta <span>(Uzupełnij dane do dokumentu sprzedaży. Jeżeli chcesz fakturę VAT, zaznacz pole poniżej.)</span></div>
        <div class="kcalmar-input">
          <input type="text" name="client_first_name" id="client_first_name" required="required" v-model="clientFirstName"/>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label for="client_first_name" class="control-label">Imię*</label>
          <span class="error" v-if="getError('client_first_name')">{{ getError('client_first_name') }}</span>
        </div>
        <div class="kcalmar-input">
          <input type="text" name="client_last_name" id="client_last_name" required="required" v-model="clientLastName"/>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label for="client_last_name" class="control-label">Nazwisko*</label>
          <span class="error" v-if="getError('client_last_name')">{{ getError('client_last_name') }}</span>
        </div>
        <div class="kcalmar-input">
          <input type="text" name="client_phone" id="client_phone" required="required" v-model="clientPhone"/>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label for="client_phone" class="control-label">Telefon</label>
          <span class="error" v-if="getError('client_phone')">{{ getError('client_phone') }}</span>
        </div>
      </div>
      <div class="invoice-box">
        <div class="kcalmar-checkbox">
          <input id="invoice" type="checkbox" v-model="invoice" checked>
          <label for="invoice" class="invoice-checkbox-label">Chcę otrzymać fakturę (UWAGA! Jeśli pominiesz ten punkt, nie będziesz miał możliwości uzyskania faktury w terminie późniejszym)</label>
        </div>
      </div>
      <div class="animated" :class="{ 'slided-up': invoice == false, 'slided-down': invoice == true }">
        <div class="row white-box animated invoice-data">
          <div class="header">Dane do faktury</div>
            <div class="kcalmar-input">
              <input type="text" name="document_name" id="document_name" required="required" v-model="documentName"/>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="document_name" class="control-label">Imię i nazwisko lub nazwa firmy*</label>
              <span class="error" v-if="getError('document_name')">{{ getError('document_name') }}</span>
            </div>
            <div class="kcalmar-input">
              <input type="text" name="document_street" id="document_street" required="required" v-model="documentStreet"/>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="document_street" class="control-label">Adres*</label>
              <span class="error" v-if="getError('document_street')">{{ getError('document_street') }}</span>
            </div>
            <div class="kcalmar-input">
              <input type="text" name="document_postal_code" id="document_postal_code" required="required" v-model="documentPostalCode"/>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="document_postal_code" class="control-label">Kod pocztowy*</label>
              <span class="error" v-if="getError('document_postal_code')">{{ getError('document_postal_code') }}</span>
            </div>
            <div class="kcalmar-input">
              <input type="text" name="document_city" id="document_city" required="required" v-model="documentCity"/>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="document_city" class="control-label">Miasto*</label>
              <span class="error" v-if="getError('document_city')">{{ getError('document_city') }}</span>
            </div>
            <div class="kcalmar-input nip-field">
              <input type="text" name="document_vat_id" id="document_vat_id" :disabled="vatIdNotRequired" :required="!vatIdNotRequired ? 'required' : false" v-model="documentVatId"/>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="document_vat_id" class="control-label">NIP{{ !vatIdNotRequired ? '*' : '' }}</label>
              <span class="error" v-if="getError('document_vat_id')">{{ getError('document_vat_id') }}</span>
            </div>
            <div class="kcalmar-checkbox">
              <input id="nip-available" type="checkbox" v-model="vatIdNotRequired" @change="vatRequireChange">
              <label for="nip-available" class="invoice-checkbox-label">Nie posiadam NIP. Zaznaczając to pole nie będzie możliwości późniejszego podania NIP dla faktury VAT.</label>
            </div>
        </div>
      </div>
      <div class="payment-methods">
        <div class="payment-method-header">Wybierz metodę płatności</div>
        <div class="row">
          <div class="kcalmar-radio cc-method" :class="{ active: paymentMethod == 'cc-method' }">
            <input
              id="cc-method"
              value="cc-method"
              type="radio"
              name="payment-method"
              v-model="paymentMethod"
            >
            <label for="cc-method">
              Odblokuj dostęp natychmiast
              <div class="payment-card-description">(Płatność kartą płatniczą)</div>
            </label>
            <img src="../../assets/img/common/visa.png" alt="Visa">
            <img src="../../assets/img/common/mastercard.png" alt="Mastercard">
          </div>
          <div class="column-spacer"></div>
          <div
            class="kcalmar-radio transfer-method" :class="{ active: paymentMethod == 'transfer-method' }">
            <input
              id="transfer-method"
              value="transfer-method"
              type="radio" name="payment-method"
              v-model="paymentMethod"
            >
            <label for="transfer-method">Płatność PayU</label>
            <img class="payu-logo payu-logo1" src="../../assets/img/common/payu_installments.png" alt="PayU Raty">
            <img class="payu-logo payu-logo2" src="../../assets/img/common/payu.png" alt="PayU">
          </div>
        </div>
      </div>
      <template v-if="false">
        <div class="pay_cycle">
          <div class="kcalmar-checkbox">
            <input
              v-model="recurringPayment"
              id="pay_cycle"
              type="checkbox"
              name="pay_cycle"
              title="płatność cykliczna"
            >
            <label for="pay_cycle">
              <div class="pay-cycle-description">
                <div>Oszczędzaj 3zł miesięcznie i zapewnij sobie nieprzerwany dostęp do programu korzystając z płatności cyklicznej.</div>
                <div>Wybieram płatność cykliczną</div>
                <div>Dla Twojej wygody kolejna należność zostanie pobrana automatycznie, możesz to w każdym momencie wyłączyć. Uwaga! Nigdy nie pobieramy pieniędzy bez Twojej zgody.</div>
              </div>
            </label>
          </div>
        </div>
      </template>
      <div class="button-wrapper">
        <router-link class="back-step-button" :to="{ name: 'PaymentStepExtra' }">Cofnij</router-link>
        <div class="button-wrapper-next">
          <span class="non-field-errors" v-if="getError('non_field_errors')">{{ getError('non_field_errors') }}</span>
          <component v-bind:is="paymentButtonType" v-on:payment-click="paymentClick"></component>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from '../../mixin'
import PaymentButton from '@/components/PaymentCreator/PaymentButton.vue'
import RecurringPaymentButton from '@/components/PaymentCreator/RecurringPaymentButton.vue'

export default {
  data () {
    return {
      paymentButtonType: 'PaymentButton',
      errors: {},
      packageExtendError: [],
      packageExtendCheckbox: false,
      planMap: {
        'basic': 0,
        'master': 1,
        'premium': 2,
        'vip': 3
      },
      periodMap: {
        '1': 0,
        '6': 1,
        '12': 2,
        '24': 3
      },
      selectedPlanNameDict: {
        'Basic': 0,
        'Student 2018': 0,
        'Testowy': 0,
        'Master': 1,
        'Master+Szablony 2018': 1,
        'Master 2018': 1,
        'Premium': 2,
        'Premium 2018': 2,
        'Edu-Premium': 2,
        'VIP': 3
      }
    }
  },
  name: 'PaymentStepSummary',
  components: {
    PaymentButton,
    RecurringPaymentButton
  },
  mixins: [mixin],
  computed: {
    ...mapState([
      'user',
      'recurringPaymentAvailable',
      'config',
      'plans',
      'selectedPlanIndex'
    ]),
    ...mapGetters([
      'getSummary',
      'systemDocumentType',
      'isVip',
      'getAllServices'
    ]),
    clientFirstName: {
      get () {
        return this.$store.state.form.clientFirstName
      },
      set (value) {
        this.$store.commit('setFormValue', ['clientFirstName', value])
      }
    },
    clientLastName: {
      get () {
        return this.$store.state.form.clientLastName
      },
      set (value) {
        this.$store.commit('setFormValue', ['clientLastName', value])
      }
    },
    clientPhone: {
      get () {
        return this.$store.state.form.clientPhone
      },
      set (value) {
        this.$store.commit('setFormValue', ['clientPhone', value])
      }
    },
    documentName: {
      get () {
        return this.$store.state.form.documentName
      },
      set (value) {
        this.$store.commit('setFormValue', ['documentName', value])
      }
    },
    documentStreet: {
      get () {
        return this.$store.state.form.documentStreet
      },
      set (value) {
        this.$store.commit('setFormValue', ['documentStreet', value])
      }
    },
    documentPostalCode: {
      get () {
        return this.$store.state.form.documentPostalCode
      },
      set (value) {
        this.$store.commit('setFormValue', ['documentPostalCode', value])
      }
    },
    documentCity: {
      get () {
        return this.$store.state.form.documentCity
      },
      set (value) {
        this.$store.commit('setFormValue', ['documentCity', value])
      }
    },
    documentVatId: {
      get () {
        return this.$store.state.form.documentVatId
      },
      set (value) {
        this.$store.commit('setFormValue', ['documentVatId', value])
      }
    },
    code: {
      get () {
        return this.$store.state.form.code
      },
      set (value) {
        this.$store.commit('setFormValue', ['code', value])
        this.codeError = ''
      }
    },
    codeVisible: {
      get () {
        return this.$store.state.form.codeVisible
      },
      set (value) {
        this.$store.commit('setFormValue', ['codeVisible', value])
      }
    },
    codeError: {
      get () {
        return this.$store.state.form.codeError
      },
      set (value) {
        this.$store.commit('setFormValue', ['codeError', value])
      }
    },
    paymentMethod: {
      get () {
        return this.$store.state.paymentMethod
      },
      set (value) {
        this.$store.commit('setPaymentMethod', value)
      }
    },
    invoice: {
      get () {
        return this.$store.state.invoice
      },
      set (value) {
        this.$store.commit('setInvoice', value)
      }
    },
    vatIdNotRequired: {
      get () {
        return this.$store.state.vatIdNotRequired
      },
      set (value) {
        this.$store.commit('setVatIdNotRequired', value)
      }
    },
    recurringPayment: {
      get () {
        return this.$store.state.recurringPayment
      },
      set (value) {
        this.$store.commit('setRecurringPayment', value)
      }
    },
    sendingOrder: {
      get () {
        return this.$store.state.sendingOrder
      },
      set (value) {
        this.$store.commit('setSendingOrder', value)
      }
    },
    systemDocumentType: function () {
      if (this.invoice) {
        return 1 // INVOICE
      } else {
        return 3 // BILL_OF_SALE
      }
    },
    planData () {
      const dataDict = {
        userPlanName: '',
        availablePlans: []
      }
      dataDict.userPlanName = this.user.planName
      dataDict.availablePlans = this.plans
      return dataDict
    }
  },
  methods: {
    ...mapMutations([
      'selectPlan',
      'selectPeriod'
    ]),
    ...mapActions([
      'checkCode'
    ]),
    vatRequireChange: function () {
      this.documentVatId = ''
    },
    createOrder: function (cardToken) {
      this.errors = {}
      let summary = this.getSummary
      if (summary.packageDurationChange) {
        if (!this.packageExtendCheckbox) {
          if (this.packageExtendError.length === 0) {
            this.packageExtendError.push('Musisz zaakceptować to pole jeśli chcesz przejść dalej')
          }
          return
        }
      }
      this.sendingOrder = true
      let url = process.env.VUE_APP_PAYMENTS_SERVICE_HOST + process.env.VUE_APP_PAYMENTS_SERVICE_CREATE_ORDER_PATH
      let data = {
        client_email: this.user.email,
        client_first_name: this.clientFirstName,
        client_last_name: this.clientLastName,
        client_phone: this.clientPhone,
        document_name: this.documentName,
        document_type: this.systemDocumentType,
        document_street: this.documentStreet,
        document_city: this.documentCity,
        document_postal_code: this.documentPostalCode,
        document_country: 'Polska',
        services_ids: this.getAllServices,
        code: this.code,
        price_net: summary.totalPriceNet.toFixed(2),
        price_gross: summary.totalPriceGross.toFixed(2),
        payment_method: this.paymentMethod,
        recurring_payment: this.recurringPayment,
        disposable_token: cardToken,
        vat_id_not_required: this.vatIdNotRequired
      }
      if (!this.vatIdNotRequired) {
        data.document_vat_id = this.documentVatId
      } else {
        data.document_vat_id = ''
      }

      axios.post(url, data).then((response) => {
        let redirectUrl = response.data.redirect_url
        window.location.href = redirectUrl
      }).catch((error) => {
        let data = error.response.data
        if (error.response.status === 400) {
          this.errors = data
          if (data.hasOwnProperty('code')) {
            this.$store.commit('setCodeError', data['code'][0])
          }
        }
        this.sendingOrder = false
      })
    },
    paymentClick: function () {
      const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
      const dataLayerEvent = {
        'event': 'go-to-payment_click'
      }
      utmParams.forEach(param => {
        const value = localStorage.getItem(param)
        if (value) {
          dataLayerEvent[param] = value
        }
      })
      window.dataLayer.push(dataLayerEvent)

      if (!this.sendingOrder) {
        this.$store.dispatch('checkCode').then(() => {
          this.createOrder('')
        }).catch(() => {
        })
      }
    },
    vuePayUCallback: function (data) {
      if (!this.sendingOrder) {
        this.createOrder(data.value)
      }
    },
    showCode: function () {
      this.codeVisible = true
    },
    getError: function (error) {
      if (this.errors.hasOwnProperty(error)) {
        return this.errors[error][0]
      }
      return ''
    }
  },
  mounted: function () {
    // eslint-disable-next-line
    payUCallback = this.vuePayUCallback
    /* T364 auto code discovery */
    let autoCode = this.config.autoCodes[this.selectedPlanIndex]
    if (autoCode !== undefined) {
      this.code = autoCode
      this.showCode()
      this.$store.dispatch('checkCode')
    }
  },
  watch: {
    planData: function (data) {
      if (this.$route.params.plan) {
        const cpIndex = this.planMap[this.$route.params.plan]
        if (data.availablePlans.length > 0 && data.userPlanName !== '') {
          let spIndex = this.selectedPlanNameDict[data.userPlanName]
          if (spIndex === undefined) {
            spIndex = 3
          }
          if (data.availablePlans.length > cpIndex && cpIndex >= 0 && cpIndex >= spIndex) {
            this.selectPlan(cpIndex)
          } else {
            this.selectPlan(spIndex)
            this.$router.push({ name: 'PaymentStepPlan' })
          }
        } else {
          this.selectPlan(cpIndex)
        }
      }
      if (this.$route.params.period) {
        this.selectPeriod(this.periodMap[this.$route.params.period])
      }
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.showCode()
        this.$store.dispatch('checkCode')
      }
    },
    recurringPayment: function () {
      if (this.recurringPayment) {
        this.paymentButtonType = 'RecurringPaymentButton'
      } else {
        this.paymentButtonType = 'PaymentButton'
      }
    }
  }
}
</script>

<style scoped>
.discounts-extra.has-tooltip {
  color: #000;
}

.discounts-extra.has-tooltip .tooltip {
  right: -25px;
  left:  inherit;
  bottom: calc(100% + 15px);
}

.discounts-extra.has-tooltip .tooltip:before {
  right: 18px;
  left: inherit;
}

td.package-extend-info .discount-name {
  color: #FF0061;
}

.step-four-content{
  margin-top: 50px;
}
.row {
  font-family: 'Roboto-Regular';
  justify-content: center;
}
.row.invoice-data {
  justify-content: start;
}
.white-box {
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
  margin-bottom: 30px;
  padding: 10px 10px 25px 10px;
}
.main-table {
  border-spacing: 0;
  width: 100%;
}
.main-table tr {
  background-color: #F2F2F2;
}
.main-table th {
  border: 0;
  background-color: #F2F2F2;
  color: #9B9B9B;
  font-size: 12px;
  font-weight: 700;
  padding: 17px 20px 14px 20px;
  text-align: right;
  text-transform: uppercase;
}
.main-table th.description {
  text-align: left;
}
.main-table td {
  color: #1A1A1A;;
  background-color: #FFFFFF;
  font-size: 14px;
}
td.summary-section {
  border-bottom: 1px solid #CDCDCD;
  color: #999999;
  font-size: 15px;
  padding: 35px 20px 10px 20px;
  text-transform: uppercase;
}
td.description {
  padding: 10px 20px 10px 20px;
  width: 60%;
}
td.duration-change-important{
  font-size: 18px;
  color: #FF0061;
  text-align: right;
  padding-right: 15px;
  padding-top: 4px;
}
td.description img {
  vertical-align: bottom;
}
.main-table .gray {
  color: #999999;
}
td.gross, td.gross-after-discount {
  font-weight: 700;
}
tr.discounts td.net,
tr.discounts td.gross,
tr.discounts td.gross-after-discount,
td.discount, .discounts-extra {
  color: #41CDA8;
  text-align: right;
}
.extra {
  margin-right: 4px;
}
.package-extend-error{
  color: #FF0061;
  margin-bottom: 20px;
}
tr.discounts{
  outline: 1px solid #FF0061;
}
td.package-extend-info{
  font-size: 16px;
  color: #000;
}
.special-discount-img {
  position: relative;
  top: -3px;
}
.row.summary {
  justify-content: space-between;
}
.summary-discount {
  background-color: #FFFFFF;
  border: 1px solid #CDCDCD;
  border-radius: 5px;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
  height: 45px;
  margin-bottom: 30px;
  position: relative;
  width: 280px;
}
.summary-discount-link {
  padding-bottom: 30px;
  text-decoration: underline;
}
.summary-discount input {
  border: 0;
  font-size: 14px;
  height: 35px;
  margin: 5px;
  outline: none;
  width: 170px;
}
.summary-discount .summary-calculate {
  background-color: #41CDA8;
  border-radius: 0 5px 5px 0;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  padding: 16px 10px;
  position: absolute;
  top: 0;
  right: 0;
  vertical-align: middle;
  width: 80px;
}
.summary-discount .summary-discount-error {
  color: red;
  font-size: 12px;
  margin: 4px;
}
.summary-total {
  width: 360px;
}
.summary-total table {
  width: 100%;
}
.summary-total td:first-child {
  color: #9B9B9B;
  font-size: 13px;
  padding: 0 0 10px 5px ;
  text-transform: uppercase;
}
.summary-total td:last-child {
  padding: 0 5px 10px 0;
  font-size: 14px;
  font-weight: 700;
  text-align: right;
}
.summary-total .discount td:last-child {
  color: #41CDA8;
}
.summary-total .savings td:last-child {
  color: #41CDA8;
}
.summary-total .summary td {
  border-top: 1px solid #CDCDCD;
  padding-top: 20px;
}
.summary-total .summary td:last-child {
  border-top: 1px solid #CDCDCD;
  color: #41CDA8;
  font-size: 22px;
  padding-top: 20px;
}
.white-box .header {
  background-color: #F2F2F2;
  border-radius: 5px;
  color: #9B9B9B;
  font-size: 12px;
  padding: 15px 20px;
  text-transform: uppercase;
  width: 100%;
}
.white-box .header span{
  padding-left: 25px;
  text-transform: none;
}
.invoice-checkbox-label, .package-extend-checkbox-label{
  padding-top: 7px;
}
.payment-method-header {
  font-size: 25px;
  text-transform: uppercase;
  margin: 0 0 30px 0;
}
.payment-methods .kcalmar-radio {
  flex-grow: 1;
  min-width: calc(50% - 156px);
  padding-right: 125px;
  position: relative;
  min-height: 36px;
}
.payment-methods .column-spacer{
  flex-basis: 0;
  flex-grow: 2;
}
.payment-methods .kcalmar-radio img{
  position: absolute;
  top: 12px;
}
.payment-methods .kcalmar-radio.cc-method img:nth-child(3){
  right: 15px;
}
.payment-methods .kcalmar-radio.cc-method img:nth-child(4){
  right: 75px;
}
.payment-methods .kcalmar-radio.transfer-method img:nth-child(3){
  right: 15px;
}
.payment-methods .kcalmar-radio.transfer-method img:nth-child(4){
  right: 120px;
}
.payment-card-description{
  color: #999999;
  font-size: 12px;
  font-weight: 300;
}
.pay-cycle-description {
  margin: 0 0 30px 0;
}
.pay-cycle-description div:nth-child(1) {
  color: #41CDA8;
  font-weight: 700;
  margin-bottom: 5px;
}
.pay-cycle-description div:nth-child(2) {
  font-weight: 700;
  margin-bottom: 5px;
}
.kcalmar-checkbox.disabled{
  background-color: #f5f5f5;
  pointer-events: none;
}
.kcalmar-checkbox.disabled div:first-child{
  color: #999;
}
.kcalmar-checkbox.disabled label:before {
  border: 1px solid #999;
  background-color: #ddd;
}
.button-wrapper{
  z-index: 9
}
.button-wrapper-next {
  text-align: center;
}
.main-table .net, .main-table .vat, .main-table .vat_rate, .main-table .gross {
  text-align: right;
}
.non-field-errors {
  display: inline-block;
  margin: 20px;
  color: red;
  font-size: 12px;
}
.invoice-box{
  padding: 5px 0 5px 20px;
  outline: 1px solid #FF0061;
  margin-bottom: 20px;
}
.invoice-box .kcalmar-checkbox{
  margin: 10px 0 15px 0;
}
.invoice-data .kcalmar-checkbox {
  margin:30px 0 0 0;
}
.invoice-data .kcalmar-checkbox label {
  color: #ff0061;
}
.payu-logo {
  max-height: 26px;
}
@media screen and (max-width: 1082px) {
  .column-spacer{
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  .kcalmar-checkbox label:not(:empty) {
    padding-left: 25px;
  }
  .payment-methods .kcalmar-radio img[data-v-506f5922]:nth-child(4) {
      right: 65px;
  }
}
@media screen and (max-width: 600px) {
  .main-table th{
    padding: 10px;
  }
  td.description{
    width: auto;
  }
  .button-wrapper{
    justify-content: center;
  }
  .discounts-extra {
    text-align: left;
    display: block;
  }
}
@media screen and (max-width: 480px) {
  .step-four-content{
    margin-top: 0;
  }
  .white-box .header {
    padding: 15px 10px;
  }
  .white-box .header span{
    display: none;
  }
  .main-table th{
    font-size: 12px;
  }
  .main-table td{
    font-size: 12px;
    padding: 5px;
  }
  .payment-method-header{
    font-size: 16px;
  }
  .button-wrapper {
    flex-direction: column-reverse;
  }
  .button{
    padding: 22px 10px;
  }
  .kcalmar-checkbox label:not(:empty){
    padding-left: 35px;
  }
  .payment-methods .kcalmar-radio {
    padding: 10px 10px 50px 10px;
  }
  .payment-methods .kcalmar-radio img {
    position: absolute;
    top: unset;
    bottom: 12px;
    left: 55px;
  }
  .payment-methods .kcalmar-radio img:nth-of-type(2) {
    left: 105px;
  }
  .payment-methods .kcalmar-radio img.payu-logo1 {
    left: 110px;
  }
  .payment-methods .kcalmar-radio img.payu-logo2 {
    left: 55px;
  }
  .net, .vat_rate, .vat {
    display: none;
  }
}
</style>
